var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:'dropdown-item',staticStyle:{"font-size":"14px"},attrs:{"disabled":_vm.withdrawLoading},on:{"click":function($event){$event.preventDefault();return _vm.onWithDrawClick.apply(null, arguments)}}},[_vm._v(" Cancel ")])}
var staticRenderFns = []

export { render, staticRenderFns }